// a string holding markup (sub/sup, entities) as the HTML writes it
import type { ElementType, FC } from "react";

type HtmlProps = { text: string; as?: ElementType; className?: string };

const Html: FC<HtmlProps> = ({ text, as, className }) => {
  const Tag = (as ?? "span") as ElementType<{ className?: string; dangerouslySetInnerHTML: { __html: string } }>;
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default Html;
